(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["healo-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (event.target.closest('.faq-titlees')) {
      const title = event.target.closest('.faq-titlees');
      const wrap = title.closest('.faq-wrapss');
      const body = title.nextElementSibling;
      wrap.classList.toggle('faqss-active');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
